
import { format } from 'date-fns';
import Vue from 'vue';

export default Vue.extend({
	props: {
		item: { type: Object, required: true }
	},
	data() {
		return {
			expanded: false,
			format: format
		};
	},
	methods: {
		handleActionItemClick(item) {
			this.$store.commit('risolto/SET_EMAIL_DETAIL_DIALOG_MESSAGE', item.message_by_reference.reference);
			this.$store.commit('risolto/SET_EMAIL_DETAIL_DIALOG_VISIBLE', true);
		}
	}
});
